class BlockBigTextScrollingImage {
	constructor() {
		const block = document.querySelector(".block-big-text-scrolling-image");
		if (!block) {
			return;
		}

		const images = block.querySelector(".images");
		const text = block.querySelector(".text-container");
		gsap.to(images, {
			y: "-=40%",
			scrollTrigger: {
				trigger: block,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
			}
		});
		gsap.to(text, {
			y: "+=20%",
			scrollTrigger: {
				trigger: block,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
			}
		});
	}
}
